// extracted by mini-css-extract-plugin
var _1 = "Sidebar_boardButton__9TAPK";
var _2 = "Sidebar_boardCannotManage__Uwolm";
var _3 = "Sidebar_boardDraggable__HFMoF";
var _4 = "Sidebar_collapseIcon__jv3Lh";
var _5 = "Sidebar_collapseIconCollapsed__+kDVU";
var _6 = "Sidebar_content__lD3bT";
var _7 = "Sidebar_contentCompact__gT7Wo";
var _8 = "Sidebar_footerButton__HlUvn";
var _9 = "Sidebar_footerButtonIcon__pbyzR";
var _a = "Sidebar_githubGreen__rIW+X";
var _b = "Sidebar_githubGrey__wPe1v";
var _c = "Sidebar_githubNotifications__g8Rrm";
var _d = "Sidebar_hoverButton__3QO5F";
var _e = "Sidebar_icon__45Dek";
var _f = "Sidebar_notification__D3cTn";
var _10 = "Sidebar_reorderBoardsButton__jIPnu";
var _11 = "Sidebar_scrollable__H9d++";
var _12 = "Sidebar_sidebar__x32HG";
var _13 = "Sidebar_sidebarActive__BvoI1";
var _14 = "Sidebar_sidebarButton__Ijjng";
var _15 = "Sidebar_sidebarButtonPadding__TfjhA";
var _16 = "Sidebar_sidebarCompact__sKuwP";
var _17 = "Sidebar_sidebarHidden__Uxbij";
var _18 = "Sidebar_sidebarItem__kqQp0";
var _19 = "Sidebar_sidebarItemActive__dVNYH";
var _1a = "Sidebar_sidebarItemBoard__RchCi";
var _1b = "Sidebar_sidebarItemInner__dF852";
var _1c = "Sidebar_sidebarItemProject__nWjC8";
var _1d = "Sidebar_sidebarTitle__BSllT";
var _1e = "Sidebar_sidebarTitleIcon__Fj8R7";
var _1f = "Sidebar_toggleSidebarButton__BdAYI";
var _20 = "Sidebar_wrapper__4x7Tf";
export { _1 as "boardButton", _2 as "boardCannotManage", _3 as "boardDraggable", _4 as "collapseIcon", _5 as "collapseIconCollapsed", _6 as "content", _7 as "contentCompact", _8 as "footerButton", _9 as "footerButtonIcon", _a as "githubGreen", _b as "githubGrey", _c as "githubNotifications", _d as "hoverButton", _e as "icon", _f as "notification", _10 as "reorderBoardsButton", _11 as "scrollable", _12 as "sidebar", _13 as "sidebarActive", _14 as "sidebarButton", _15 as "sidebarButtonPadding", _16 as "sidebarCompact", _17 as "sidebarHidden", _18 as "sidebarItem", _19 as "sidebarItemActive", _1a as "sidebarItemBoard", _1b as "sidebarItemInner", _1c as "sidebarItemProject", _1d as "sidebarTitle", _1e as "sidebarTitleIcon", _1f as "toggleSidebarButton", _20 as "wrapper" }
